import React, { useState, useEffect } from "react";
import { useSwapData } from "../hooks/useSwapData";
import { getMarket } from "../config/markets";
import MarketSwitch from "./MarketSwitch";
import PricePanel from "./PricePanel";
import SwapCard from "./SwapCard";

export default function DexHome() {
  const [marketKey, setMarketKey] = useState("scn");
  const market = getMarket(marketKey);
  const { data, refresh } = useSwapData(market);

  // Swap the whole palette by toggling the root theme attribute (no refresh).
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", market.theme);
  }, [market.theme]);

  return (
    <main className="app-content">
      <div className="stack">
        <MarketSwitch active={marketKey} onChange={setMarketKey} />
        <PricePanel market={market} data={data} />
        <SwapCard market={market} data={data} refresh={refresh} />
      </div>
    </main>
  );
}
